import React from "react";
import { Grid } from "semantic-ui-react";
import styled from "styled-components";
import Background from "../../../assets/images/sprites/MarketplaceShapes.png";
import Osmosis from "../../../assets/images/sprites/Osmosis.png";
import StarLeft from "../../../assets/images/sprites/starLeft.svg";
import StarRight from "../../../assets/images/sprites/starRight.svg";

export default function MarketPlaceHeader() {
  return (
    <HeaderContainer>
      <ContentContainer>
        <TextContainer>
          <StarL><img src={StarLeft} alt={""} /></StarL>
          <StarR><img src={StarRight} alt={""} /></StarR>

          <HeaderTitle>Refer your friends for 50% off Osmosis</HeaderTitle>
          <HeaderParagraph>
            <p>
              Osmosis provides you with the right study techniques to help you
              retain, understand, and study more efficiently throughout med
              school. Excel in your classes, ace the USMLE®, and be better
              prepared for clinicals when you learn by Osmosis.
            </p>
            <p>
              In the chat on the bottom right corner, share the email of the
              person that referred you
            </p>
          </HeaderParagraph>
        </TextContainer>
          <Rectangle>
            <Image src={Osmosis} alt={""} />
          </Rectangle>
      </ContentContainer>
    </HeaderContainer>
  )
}


const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  max-width: 1200px;
`;
const TextContainer = styled.div`
  position: relative;
  width: 60%;
  padding: 16px 60px;
  margin-bottom: 16px;
  @media (max-width: 980px) {
    font-size: 0.8em;
  }
  @media (max-width: 720px) {
    width: 100%;

  }
`;
const HeaderTitle = styled.h3`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 3.8em;
  font-weight: bold;
  margin-top: 48px;
  letter-spacing: -1px;
  line-height: 60px;
  @media (max-width: 980px) {
    font-size: 3em;
    line-height: 40px;
  }
`;

const HeaderParagraph = styled.p`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 18px;
  letter-spacing: 0px;
  line-height: 28px;
  margin-top: 30px;
`;

const Rectangle = styled.div`
  height: 300px;
  width: 495px;
  background: url(${Background});
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 980px) {
    height: 180px;
    width: 300px;
  }
  @media (max-width: 720px) {
    display: none;
  }
`;
const Image = styled.img`
  width: 380px;
  height: 380px;
  object-fit: contain;
  @media (max-width: 980px) {
    width: 280px;
  }
`;
const StarL = styled.div`
  height: 50;
  width: 50;
  background-size: cover;
  position: absolute;
  left: -20px;
`;
const StarR = styled.div`
  height: 50;
  width: 50;
  background-size: cover;
  position: absolute;
  right: -20px;
`;